import { StyleSheet } from 'react-native';
import { BsMap } from '../config/bs';
import { useDeepMemo } from './useDeepMemo';
export function useStyle(styles) {
    return useDeepMemo(() => {
        const styleObj = {};
        Object.keys(styles !== null && styles !== void 0 ? styles : {}).forEach((key1) => {
            const keyObj = styles[key1];
            Object.keys(keyObj).forEach((key2) => {
                if (!styleObj[key1]) {
                    styleObj[key1] = {};
                }
                if (BsMap[key2]) {
                    styleObj[key1][BsMap[key2]] = keyObj[key2];
                }
                else {
                    styleObj[key1][key2] = keyObj[key2];
                }
            });
        });
        return StyleSheet.create(styleObj);
    }, [styles]);
}
